import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, ReferralLeadsResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof ReferralLeadsResponseDataSchema>>

const getReferralLeadsQueryKey = () => ["referralLeads"]

export const getReferralLeadsQuery = () =>
  queryOptions({
    queryKey: getReferralLeadsQueryKey(),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/referrals")
      return data.data
    },
  })
